<template>

  <div>
    <table class="table table-striped table-bordered">
      <tbody>
        <tr>
          <td>Display Phone Number</td>
          <td>{{ metadata.display_phone_number || 'Undefined' }}</td>
        </tr>
      </tbody>
    </table>

    <PageTemplates :connection-id="id" />
  </div>

</template>

<script>
import PageTemplates from './PageTemplates'

export default {
  name: 'WhatsappPage',
  components: {
    PageTemplates
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    integration: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    id () {
      return this.connection._id
    },
    metadata () {
      return this.connection.metadata || {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integrations/connectors/whatsapp/Page.vue